import { useEffect, useState } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import {
  TITLE,
  ALL_DYNA_CONTACT_LIST,
  ALL_EVENTS_LIST,
  ABOVE_TITLE,
  ALL_BANNERS,
} from "./WelcomeKyndrylConstants";
import { BUTTON_NAME, BUTTON_LINK } from "./WelcomeKyndrylConstants";

// Images
import homepageBanner from "../../../assets/img/partnerPortal/homepage.png";
import kyndryl from "../../../assets/img/partnerPortal/welcomeKyndryl/kyndryl-logo.svg";
import checkmark from "../../../assets/img/partnerPortal/welcomeAccenture/checkmark-small.svg";
import demo_banner from "../../../assets/img/partnerPortal/welcomePage/demoImg.png";

// import firstImage from '../../assets/img/partnerProgram/sectionImage.png';
// Scss
import "../../../assets/css/partnerProgram.scss";
import "../../../assets/css/partnerPortal/welcome.scss";

// actions
import * as partnerPortalAction from "../../../actions/partnerPortal/PartnerPortalAction";

import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Image from "react-bootstrap/Image";
import NewsSection from "../../../components/NewsSection";
import Title from "../../../components/Title";
import ButtonOne from "../../../components/ButtonOne";
import ContactSection from "../../../components/ContactSection";
import PartnerCertificationsDTO from "../../../models/PartnerCertificationsDTO";
import VidyardPlayer from "../../../utils/VidyardPlayer";
import { Carousel } from "react-bootstrap";

function WelcomeKyndryl() {
  let history = useHistory();
  const [certificationList, setCertificationList] =
    useState<Array<PartnerCertificationsDTO>>();
  const [buttonName, setButtonName] = useState("Show more");

  useEffect(() => {
    canYouHaveAccess();
    getCertification();
  }, []);

  return (
    <>
      <div>
        <BannerOne
          bannerImage={homepageBanner}
          title={TITLE}
          logo2={kyndryl}
          aboveTitle={ABOVE_TITLE}
          logoWidth={"100%"}
          buttonName={BUTTON_NAME}
          buttonLink={BUTTON_LINK}
          targetFirstButton="_parent"
          marginTop={"addMarginTop2"}
        />
        <Container className="mt-5">
          <div className="welcomeBanner mb-5">
            <div className="videoStyle">
              <VidyardPlayer uuid="NsBZn4MsmFHniUibL9RcXG" type="lightbox" />
            </div>
            <div className="welcomeQuote">
              <div className="quote">
                "Observability is the ingredient necessary for clients to
                accelerate modernization, development, consolidate tools and
                build a foundation for resilience. And as a service provider,
                Kyndryl sees the value in combining our end to end services with
                the Dynatrace observability platform to deliver on those
                capabilities and drive business value for our clients."
              </div>
              <div className="quoteSign">
                <div className="quoteSignatureGeneral fontWeight700">
                  Firas Bouz
                </div>
                <div className="quoteSignatureGeneral fontWeight400">
                  VP Business Development and Solutions, Kyndryl
                </div>
              </div>
            </div>
          </div>

          <Row>
            <Col xs={12} sm={12} md={12} lg={8} className="mb-5">
              <Carousel>
                {ALL_BANNERS.map((b) => (
                  <Carousel.Item>
                    <a href={b.link} target={b.target}>
                      <Image src={b.image} width={b.width} />
                    </a>
                  </Carousel.Item>
                ))}
              </Carousel>

              <div>
                <Title className={"mt-5"} title={"WELCOME"} />
                <div className="welcomeMessageSection mt-3">
                  <div className="contactGeneral fontWeight400">
                    Together, Kyndryl and Dynatrace help our mutual customers
                    accelerate and enhance decision-making by tapping into the
                    combined potential of AIOps and unified observability and
                    security, enabling organizations to innovate faster,
                    collaborate more efficiently, and gain insights that deliver
                    new business value.
                  </div>
                  <div className="welcomeList">
                    <div className="contactGeneral fontWeight800">
                      Partnership Highlights
                    </div>
                    <div className="welcomeListRow">
                      <img src={checkmark} />
                      <div className="contactGeneral fontWeight400">
                        On Nov. 1, 2023, Kyndryl & Dynatrace announced the
                        elevation of our mutual partnership to strategic global
                        alliance status, building upon two years of previous
                        success:
                        <br />
                        <div className="ml-5">
                          2021 - Dynatrace established as the internal standard
                          for the Office of the CIO.
                        </div>
                        <div className="ml-5">
                          2022 – signing of a world-wide partnership agreement.
                        </div>
                      </div>
                    </div>
                    <div className="welcomeListRow">
                      <img src={checkmark} />
                      <div className="contactGeneral fontWeight400">
                        Kyndryl holds
                        <br />
                        <div className="ml-5">
                          66 Dynatrace Associate certifications
                        </div>
                        <div className="ml-5">
                          5 Dynatrace Professional certifications
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <Title className={"mt-5"} title={"WHAT TO KNOW"} />

                <div className="welcomeList mt-3">
                  <div className="contactGeneral fontWeight800">Assets</div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Tool Consolidation Offer Guide -{" "}
                      <a
                        target="_blank"
                        href="https://portal-media.ziftsolutions.com/images/8a99822f842a7fe701843912a4d0139b/Kyndryl/kyndryl-tool-consolidation.pdf"
                      >
                        view
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight800">
                    Thought leadership
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Dynatrace ranked #1 in 6 of 6 Use Cases in 2023 Gartner®
                      Critical Capabilities for APM and Observability report -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/gartner-critical-capabilities-for-application-performance-monitoring-observability/"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Dynatrace named a Leader in the 2023 Gartner MQ for APM &
                      Observability -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/monitoring/gartner-magic-quadrant-for-application-performance-monitoring-observability/"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Forrester Wave: Dynatrace named a Leader in AIOps -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/info/reports/forrester-aiops-wave-report/"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight800">
                    Press Releases
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      US: Kyndryl and Dynatrace Announce Global Alliance -{" "}
                      <a
                        target="_blank"
                        href="https://www.kyndryl.com/in/en/about-us/news/2023/11/aiops-partnership-with-dynatrace"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Europe: Kyndryl and Dynatrace go to market on
                      observability -{" "}
                      <a
                        target="_blank"
                        href="https://www.iteuropa.com/news/kyndryl-and-dynatrace-go-market-observability"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      India: Dynatrace & Kyndryl Form a Partnership to Amplify
                      Business Potential -{" "}
                      <a
                        target="_blank"
                        href="https://analyticsindiamag.com/dynatrace-kyndryl-form-a-partnership-to-amplify-business-potential"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight800">Training</div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Check our role-based training and/or schedule for one of
                      our bootcamps -{" "}
                      <a
                        target="_parent"
                        href="https://partners.dynatrace.com/#/page/enablement"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                </div>
              </div>

              {/* <div>
                        <Title className={"mt-5"} title={"Partner sales tools"}/>
                        <ItemSection itemList={ALL_TOOLS_LIST}/>
                    </div> */}

              <div>
                <Title className={"mt-5"} title={"WHAT TO SHOW"} />
                <div className="w-100 mt-4 ">
                  <VidyardPlayer
                    uuid="ooe9DnW62RgSgeJLF1983S"
                    type="lightbox"
                  />
                </div>
                <div className="cardDemo mt-4">
                  <div className="demoContent">
                    <Title
                      withoutLine={true}
                      classNameText="fontSize18"
                      title={
                        <div>
                          Access our demo<br></br> environment to deliver the
                          <br></br> best presentations to your prospects
                        </div>
                      }
                    />
                    <ButtonOne
                      text={"Learn more"}
                      classNameOfA={"wid45"}
                      className={"pad7"}
                      link={"https://demo.live.dynatrace.com/"}
                      withoutIcon={true}
                    />
                  </div>
                  <img className="demoImgCard" src={demo_banner} width="50%" />
                </div>
              </div>
            </Col>
            {/* SECOND COLUMN */}
            <Col xs={12} sm={12} md={12} lg={4}>
              {/* <div className="frameOne">
                        <Title title={"REGISTER A PDR"} className="width100"/>
                        <NewsSection newsList={CREATE_PDR} arrowWidth={"14%"}/>
                    </div> */}
              <div className="frameOne ">
                <Title title={"NEWS, WEBINARS & EVENTS"} className="width100" />
                <NewsSection
                  newsList={ALL_EVENTS_LIST}
                  buttonName={buttonName}
                  action={ShowMoreOrLessEvents}
                />
              </div>
              <div className="frameOne mt-5">
                <Title title={"DYNATRACE CONTACTS"} className="width100" />
                <ContactSection contactList={ALL_DYNA_CONTACT_LIST} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        history.push("/not-found");
      }
    } catch (err) {}
  }

  function ShowMoreOrLessEvents() {
    console.log("here");
    setButtonName(buttonName === "Show more" ? "Show less" : "Show more");
    ALL_EVENTS_LIST.forEach((e) => (e.show = !e.show));
  }

  async function getCertification() {
    partnerPortalAction
      .getPartnerCertifications("DXC", 6)
      .then((response) => {
        setCertificationList(response.data);
      })
      .catch((err) => {
        console.error("certifications not fetch!", err);
      });
  }
}

export default WelcomeKyndryl;
